// extracted by mini-css-extract-plugin
var _1 = "Checkbox_checked__h2qW4";
var _2 = "Checkbox_chooseManyCheckbox__M1ucx";
var _3 = "Checkbox_chooseManyCheckmark__0G4Gn";
var _4 = "Checkbox_disabled__tDTQK";
var _5 = "768px";
var _6 = "\"../../../shared.module.css\"";
export { _1 as "checked", _2 as "chooseManyCheckbox", _3 as "chooseManyCheckmark", _4 as "disabled", _5 as "md", _6 as "shared" }
